export enum ButtonType {
    Button = 'button',
    Submit = 'submit',
    Reset = 'reset',
}
export enum ButtonVariant {
    Primary = 'primary',
    Secondary = 'secondary',
    Exclusive = 'exclusive',
    Info = 'info',
}
